import React, { useContext } from "react"
import SurfaceLayerContext from "../../context/SurfaceLayer"
import { SoilLayerHighlighter, effectsAndImpacts } from "shared-ui"

const { getModelHighlightsFromTests } = effectsAndImpacts

export default function PitchEffects({ tests = [], filter, ...props }) {

    const [focusedLayer, setFocusedLayer] = useContext(SurfaceLayerContext)  //string

    const onPartClick = (partName) => {
        setFocusedLayer(current => current === partName ? '' : partName)
    }

    const onPartMouseEnter = (partName) => {
        setFocusedLayer(partName)
    }

    const onPartMouseLeave = (partName) => {
        setFocusedLayer('')
    }

    const highlights = getModelHighlightsFromTests(tests, 'pitch', Infinity, filter)

    return <SoilLayerHighlighter
        focusedPart={focusedLayer}
        highlights={highlights}
        onPartClick={onPartClick}
        onPartMouseEnter={onPartMouseEnter}
        onPartMouseLeave={onPartMouseLeave}
        {...props}
    />
}